module.exports = __webpack_public_path__ + "static/img/13.01f3687.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/13.png
// module id = 2+uF
// module chunks = 0